export const getLocationParams = (state: WebOrder.State) => state.location.params || {};
